import styled from 'styled-components';

export const Content = styled.div`
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: var(--color-text);

  .title {
    text-align: left;
    color: var(--color-text-muted);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
    padding: 0 0 10px;
  }

  .title-value {
    text-align: left;
    color: var(--color-text);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    padding: 0 0 26px;
    display: flex;
    gap: 15px;
    align-items: center;

    svg {
      cursor: pointer;
    }

    svg:hover {
      color: var(--color-link);
    }

    &.balance-refresh svg {
      animation: rotation 0.4s infinite linear;
      @keyframes rotation {
        from {
          transform: rotate(0deg);
        }
        to {
          transform: rotate(359deg);
        }
      }
    }
  }

  .select {
    background: var(--color-page);
    height: 40px;
    margin: 0 0 20px;
  }

  .buttonWrapper {
    display: flex;
    grid-gap: 10px;
    margin-top: 30px;
  }

  .errorsWrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;

    &.active {
      padding-top: 20px;
    }

    .page-error {
      margin: 0;
    }
  }

  .text-end {
    font-weight: 600;
    font-size: 16px;
    text-align: right;
    color: var(--color-text);
    line-height: 40px;
  }

  .description-text {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    text-align: center;
    white-space: nowrap;
    color: var(--color-text);
    margin: 0;
  }

  .dflex {
    display: flex;
    gap: 20px;
    justify-content: space-between;
    border-top: 1px solid #d5ddf2;
    line-height: 40px;
    text-align: left;
    white-space: nowrap;

    & span {
      font-weight: 600;
      font-size: 12px;
      color: var(--color-text-muted);
    }
  }

  & .noBorder {
    margin-top: 20px;
    border: none;
  }
`;
